var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
})},[_c('div',[_c('v-icon',{attrs:{"color":"grey","large":""}},[_vm._v(" mdi-magnify ")])],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grey--text"},[_c('i',[_vm._v(" Nenhuma busca recente ")])])
}]

export { render, staticRenderFns }